// libs
import React, { memo } from 'react';
import ArrowRight from '@nykaa/ui-components/Icons/chevron-right-small';

// styles
import {
  Container,
  SubTitle,
  AnchorTitle,
  TextTitle,
  AnchorVisitStore,
  TitleWrapper,
  ActionContainer,
  TitleContainer,
  ProductTitle,
  IconWrapper,
} from './styles';

// components
import ShareLink from 'shared/layouts/DetailsPage/components/ShareLink';

// helpers
import { storeAnalyticsDataInLocal } from 'shared/helpers/storage/storeData';
import { trackBrandNameClicked } from 'shared/layouts/DetailsPage/analytics';
import { getEligibleVariantName } from 'shared/components/ExperimentV2/helpers';

// constants
import { BRAND_CLICK_TRACK_LOCATION } from 'shared/helpers/analytics/constants/pdpEvents';
import { SEARCH_BAR_EXPT_NAME, SEARCH_BAR_ELIGIBLE_VARIANT, ICON_SIZE } from 'shared/constants';

const VISIT_STORE = 'Visit Store';

// defs
interface ITitleProps {
  title: string;
  subTitle: string;
  actionUrl?: string;
  showChevron?: boolean;
}

function Title({ title, subTitle, actionUrl, showChevron }: ITitleProps) {
  const { isEligible, variant: isPdpSearchBarVariant = '' } =
    getEligibleVariantName(SEARCH_BAR_EXPT_NAME);
  const pdpSearchBarEnabled = isEligible && isPdpSearchBarVariant === SEARCH_BAR_ELIGIBLE_VARIANT;
  const onBrandTitleClicked = () => {
    if (actionUrl == undefined) {
      return;
    }
    storeAnalyticsDataInLocal({ brandTitleOrAboutUs: 'brandTitle' });
    trackBrandNameClicked(BRAND_CLICK_TRACK_LOCATION.TITLE_CLICK);
  };

  const BRAND_TITLE = actionUrl ? (
    <AnchorTitle
      href={actionUrl}
      data-test="brand-url"
      onClick={onBrandTitleClicked}
      aria-label={`${title} - ${subTitle}`}
    >
      {title}
    </AnchorTitle>
  ) : (
    <TextTitle data-test="brand-title">{title}</TextTitle>
  );

  return (
    <Container data-test="title">
      <TitleContainer>
        <TitleWrapper data-at="product-name">
          <ProductTitle>
            {BRAND_TITLE}
            {pdpSearchBarEnabled && actionUrl && showChevron && (
              <IconWrapper
                href={actionUrl}
                onClick={() => trackBrandNameClicked(BRAND_CLICK_TRACK_LOCATION.VIEW_BRAND_CTA)}
                data-test="title-chevron"
                aria-label={`${VISIT_STORE} - ${title}`}
              >
                <ArrowRight size={ICON_SIZE} />
              </IconWrapper>
            )}
          </ProductTitle>
          <SubTitle data-test="sub-title">{subTitle}</SubTitle>
        </TitleWrapper>
      </TitleContainer>

      {pdpSearchBarEnabled ? (
        <ActionContainer>
          <ShareLink size={ICON_SIZE} />
        </ActionContainer>
      ) : (
        actionUrl && (
          <AnchorVisitStore
            href={actionUrl}
            onClick={() => trackBrandNameClicked(BRAND_CLICK_TRACK_LOCATION.VIEW_BRAND_CTA)}
            data-test="visit-store-anchor"
            aria-label={`${VISIT_STORE} - ${title}`}
          >
            {VISIT_STORE}
          </AnchorVisitStore>
        )
      )}
    </Container>
  );
}

export default memo(Title);
